import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import SignupPage from "./SignupPage"; // Import the new page
import SQLPage from "./SQLPage";
import LoginPage from "./LoginPage";
import ForgotPasswordPage from "./Forgotpasswordpage";
import ProfilePage from "./ProfilePage";
import HomePage from "./HomePage";
import ContactPage from "./ContactPage";
import SQLBasicsPage from "./data/SQLBasicsPage";
import SQLIntermediatePage from "./data/SQLIntermediate";
import SQLAdvancedPage from "./data/SQLAdvanced";
import SQLInterviewPage from "./data/SQLInterview";
import SQLScenariosPage from "./data/SQLScenarios";
import SQLCompanyPage from "./data/SQLCompanyPage";
import SQLProblemPage from "./data/SQLProblemPage";
import LeaderboardPage from "./LeaderboardPage";
import BlogPage from "./BlogPage";
import BlogWritePage from "./BlogWritePage";
import BlogPostPage from "./BlogPostPage";
import PrivacyPolicyPage from "./PrivacyPolicyPage";
import TermsUse from "./TermsUse";
import PricingPage from "./PricingPage";
import StartHerePage from "./data/StartHerePage"; 
import PythonBasicsPage from "./python/PythonBasicsPage";
import PythonIntermediatePage from "./python/PythonIntermediatePage";
import PythonAdvancedPage from "./python/PythonAdvancedPage";
import PythonInterviewPage from "./python/PythonInterviewPage";
import PythonScenariosPage from "./python/PythonScenariosPage";
import PythonPage from "./python/PythonPage";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Marketing & Auth */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/home" element={<HomePage />} />
        
        {/* Dashboard & Practice Areas */}
        <Route path="/sql" element={<SQLPage />} />
        <Route path="/sql/basics/:problemSlug?" element={<SQLBasicsPage />} />
        <Route path="/sql/intermediate/:problemId?" element={<SQLIntermediatePage />} />
        <Route path="/sql/advanced/:problemId?" element={<SQLAdvancedPage />} />
        <Route path="/sql/interview/:problemId?" element={<SQLInterviewPage />}/>
        <Route path="/sql/scenarios/:problemId?" element={<SQLScenariosPage />}/>
        <Route path="/sql/company/:companySlug?/:problemSlug?" element={<SQLCompanyPage />} />
        <Route path="/sql/problem/:id" element={<SQLProblemPage />} />
        
        {/* Placeholder for future Login page to prevent 404s */}
        <Route path="/login" element={<SignupPage />} /> 
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/write" element={<BlogWritePage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />

        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsUse />} />
        <Route path="/share" element={<TermsUse />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/sql/start" element={<StartHerePage />} />

        <Route path="/python/basics/:problemSlug?" element={<PythonBasicsPage />} />
        <Route path="/python/intermediate/:problemSlug?" element={<PythonIntermediatePage />} />
        <Route path="/python/advanced/:problemSlug?" element={<PythonAdvancedPage />} />
        <Route path="/python/interview/:problemSlug?" element={<PythonInterviewPage />} />
        <Route path="/python/scenarios/:problemSlug?" element={<PythonScenariosPage />} />
        <Route path="/python" element={<PythonPage />} />


      
      </Routes>
    </BrowserRouter>
  );
}
